import { render, staticRenderFns } from "./DriversOverview.vue?vue&type=template&id=858d5282&scoped=true&"
import script from "./DriversOverview.vue?vue&type=script&lang=js&"
export * from "./DriversOverview.vue?vue&type=script&lang=js&"
import style0 from "./DriversOverview.vue?vue&type=style&index=0&id=858d5282&prod&lang=css&scoped=true&"
import style1 from "./DriversOverview.vue?vue&type=style&index=1&id=858d5282&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858d5282",
  null
  
)

export default component.exports